import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect only to image CDN (most critical)
if (typeof document !== 'undefined') {
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnect);
}
render(<App data-id="element-272" />, document.getElementById('root'));
// Load Meta Pixel after initial render (non-blocking)
if (typeof window !== 'undefined') {
  requestAnimationFrame(() => {
    setTimeout(() => {
      const script = document.createElement('script');
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s){
          if(f.fbq)return;
          n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];
          t=b.createElement(e);t.async=!0;
          t.src=v;
          s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)
        }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1688179945683486');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    }, 3000);
  });
}